import {
  createListingCategoryGetServerSideProps,
  createListingCategoryPage,
} from '@web/library/listing-category-page';
import { Animal } from 'shared/@generated/models';

const catListingsConfig = {
  animal: Animal.Cat,
  translationKey: 'cats',
};

export default createListingCategoryPage(catListingsConfig);

export const getServerSideProps = createListingCategoryGetServerSideProps(catListingsConfig);
